import * as React from "react";
import { FiSearch } from "react-icons/fi";
import { RiCloseFill } from "react-icons/ri";
import Styled from "./styled";

export interface InputBaseProps extends React.ComponentPropsWithoutRef<"input"> {
  onClear?: Function;
  onSearch?: Function;
}

const SearchInput: React.FC<InputBaseProps> = ({ onClear, onSearch, ...props }) => {
  const [value, setValue] = React.useState(props.value ?? "");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    if (props.onChange) props.onChange(e);
  };

  const handleClear = () => {
    setValue("");
    if (onClear) onClear();
  };

  const handleSearch = () => {
    if (onSearch) onSearch();
  };

  return (
    <Styled.Container>
      <FiSearch size={26} />
      <Styled.Input {...props} value={value} onChange={handleChange} />
      {value && (
        <Styled.ClearButton onClick={handleClear}>
          <RiCloseFill size={26} />
        </Styled.ClearButton>
      )}
      <Styled.SearchIconContainer onClick={handleSearch}>
        <div>Buscar</div>
      </Styled.SearchIconContainer>
    </Styled.Container>
  );
};

export default SearchInput;
